import { usePage } from "@inertiajs/react"

import { StaffLayout } from "@/components/layouts/staff-layout"
import type { CancellationReasonOption } from "@/features/staff/cancellations"
import type { KanbanOrder } from "@/features/staff/order-detail-drawer"
import { OrdersBoard } from "@/features/staff/orders-board"

type StatusColumn = {
  value: string
  label: string
}

type Props = {
  orders: KanbanOrder[]
  statusColumns: StatusColumn[]
  cancellationReasons?: CancellationReasonOption[]
}

export default function StaffLocationOrdersIndex() {
  const { orders, statusColumns, cancellationReasons } = usePage<Props>().props

  return (
    <StaffLayout>
      <OrdersBoard orders={orders} statusColumns={statusColumns} cancellationReasons={cancellationReasons} />
    </StaffLayout>
  )
}
